<template>
  <div :lang="lang" :class="{pick_date: classpick, focus_date: classFocus, bd_user_page: value}" class="datepicker-container">
    <date-picker v-model="value" v-on="$listeners" :disabled="readonly" v-on:pick="pick" v-on:clear="clear" v-on:focus="focus" v-on:blur="blur" value-type="YYYY-MM-DD" format="DD/MM/YYYY" placeholder="Fødselsdato (DD/MM/YYYY)" autocomplete="bday"></date-picker>
    <label class="label-date">{{ label }}</label>
    <small class="error">{{ validation }}</small>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/da'

export default {
  name: 'InputDatePicker',
  props: {
    value: {
      default: null,
    },
    label: {
      default: null,
    },
    validation: {
      type: String,
      default: '',
    },
    readonly: {
      default: null,
    },
  },

  components: {
    'date-picker': DatePicker,
  },

  data() {
    return {
      newValue: '',
      classFocus: false,
      classpick: false,
    }
  },

  computed: {
    inputListeners: function () {
      var vm = this
      return Object.assign(this.$listeners, {
        input: function (event) {
          vm.$emit('input', event.target.value)
        },
      })
    },
  },
  methods: {
    clear: function (event) {
      this.classpick = false
    },
    focus: function (event) {
      this.classFocus = true
    },
    blur: function (event) {
      this.classFocus = false
    },
    pick: function (event) {
      this.classpick = true
    },
  },
}
</script>
